/**
 * Display formatting shared by the economy overlays (M1.1). Formatting only:
 * nothing here derives a sim quantity — a per-mille becomes a percent, a
 * dollar count becomes `$1.2M`, and that is the whole job. Anything that
 * *means* something (a share, a yield, a cost per die) arrives from the UI
 * store already computed.
 */

/** `$1.2M`, `$340k`, `$1,234`, `-$12`. Mirrors `campaign::ui::money_text`. */
export function money(dollars: number): string {
  const abs = Math.abs(dollars);
  const sign = dollars < 0 ? '-' : '';
  if (abs >= 1e6) return `${sign}$${(abs / 1e6).toFixed(1)}M`;
  if (abs >= 1e3) return `${sign}$${(abs / 1e3).toFixed(0)}k`;
  // Die prices are cents: below ten dollars the pennies are the number.
  if (abs > 0 && abs < 10) return `${sign}$${abs.toFixed(2)}`;
  return `${sign}$${abs.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
}

/** Per-mille as a percent: `1000 → "100.0%"`. */
export function pctOfMille(mille: number, digits = 1): string {
  return `${(mille / 10).toFixed(digits)}%`;
}

/** Per-mille as a factor: `1200 → "1.20×"`. */
export function timesOfMille(mille: number): string {
  return `${(mille / 1000).toFixed(2)}×`;
}

/** Parts per million as a percent: `950000 → "95.0%"`. */
export function pctOfPpm(ppm: number): string {
  return `${(ppm / 10_000).toFixed(1)}%`;
}

/** Thousandths of a defect per cm²: `1234 → "1.23/cm²"`. */
export function d0OfMilli(milli: number): string {
  return `${(milli / 1000).toFixed(2)}/cm²`;
}

export function int(n: number): string {
  return n.toLocaleString('en-US', { maximumFractionDigits: 0 });
}
